module.exports = __webpack_public_path__ + "static/media/banner.0b35c077.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_imagerecognition/banner.png
// module id = 650
// module chunks = 0